
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetAssociatedRadarCamera as ObiTargetAssociatedRadarCameraElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-associated-radar-camera.js';
 
 
 

 
 export const ObiTargetAssociatedRadarCamera = createComponent({
   react: React,
   tagName: 'obi-target-associated-radar-camera',
   elementClass: ObiTargetAssociatedRadarCameraElement,
   events: {
     
   }
  });
 
 